import { TInputSelectInstance } from 'widgets/forms/InputSelect';
import { TInputTelInstance } from 'widgets/forms/InputTel';
import { TValidationConfig } from 'widgets/forms/BasicInput';

/**
 * @param AjaxForm Base widget for extending
 * @returns SMS Subscription Mixin class
 */
function AreaCodeMixinClassCreator(AjaxForm: import('widgets/forms/AjaxForm').TAjaxForm) {
    class AreaCodeMixin extends AjaxForm {
        /**
         * @description Widget initialization
         */
        init() {
            super.init();

            const phoneField = this.items.find(item => item && item.id && item.id.includes('phone')) as TInputTelInstance;
            const areaCodeSelector = this.items.find(item => item && item.id && item.id.includes('areaCode')) as TInputSelectInstance;

            this.updatePhoneValidation(phoneField, areaCodeSelector);
        }

        /**
         * @description Handles change event for SMS signup checkbox
         * @param areaCodeSelector - instance of TInputSelectInstance
         */
        handleAreaCodeChange(areaCodeSelector: TInputSelectInstance) {
            const phoneField = this.items.find(item => item && item.id && item.id.includes('phone')) as TInputTelInstance;

            this.updatePhoneValidation(phoneField, areaCodeSelector, true);
        }

        /**
         * @description Updates phone field validation based on areaCodeSelector
         * @param phoneField - instance of TInputTelInstance
         * @param areaCodeSelector - instance of TInputSelectInstance
         * @param validate - flag to trigger validation
         */
        private updatePhoneValidation(
            phoneField: TInputTelInstance | undefined,
            areaCodeSelector: TInputSelectInstance | undefined,
            validate: boolean = false
        ) {
            if (!phoneField || !areaCodeSelector) {
                return;
            }

            const currentValidation = phoneField.data('validationConfig') as TValidationConfig;
            const newPattern = areaCodeSelector.getSelectedOptions()?.get(0)?.getAttribute('data-validation');

            if (currentValidation && newPattern && newPattern !== currentValidation.patterns.parse) {
                currentValidation.patterns.parse = newPattern;
                phoneField.setPref('validationConfig', currentValidation);

                if (validate && phoneField.getValue()) {
                    phoneField.validate();
                }
            }
        }
    }

    return AreaCodeMixin;
}

export type TAreaCodeMixin = ReturnType<typeof AreaCodeMixinClassCreator>;

export type TAreaCodeMixinInstance = InstanceType<TAreaCodeMixin>;

export default AreaCodeMixinClassCreator;
